import PropTypes from "prop-types";
import { useRef, useCallback, memo, useContext } from "react";
import Modal from "react-modal";
import PhotoCarousel from "../../.shared/PhotoCarousel.jsx";
import "./SlideShow.scss";
import { BRANDS, MEDIA_TYPE } from "app/constants";
import AppGlobalsContext from "app/AppGlobalsContext";

// @see https://reactcommunity.org/react-modal/#documentation
const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .9)",
		zIndex: 999,
	},
};

const SlideShow = ({ isOpened, photos = [], close = () => {} }) => {
	const { brand } = useContext(AppGlobalsContext);
	const isBrandSV = brand === BRANDS.SV;
	const contentRef = useRef(null);
	const slideshowRef = useRef(null);

	const handleThumbnailClick = useCallback(() => {
		if (contentRef?.current) {
			contentRef.current.focus();
		}
	}, [contentRef?.current]);
	let filteredPhotos = photos;
	if (isBrandSV) {
		filteredPhotos = photos.filter(photo => photo?.type !== MEDIA_TYPE.VIDEO);
	}

	return (
		<Modal
			isOpen={isOpened}
			style={style}
			onRequestClose={close}
			className="slideshow__modal"
			overlayClassName="slideshow__overlay"
			contentRef={node => {
				contentRef.current = node;
			}}
			ariaHideApp={false}
		>
			<div className="slideshow__close" onClick={close}>
				<i className="icon icon--cross-dark" />
			</div>
			<div className="slideshow">
				<PhotoCarousel
					isSlideshowMode={true}
					ref={slideshowRef}
					photos={filteredPhotos}
					onThumbnailClick={handleThumbnailClick}
				/>
			</div>
		</Modal>
	);
};

SlideShow.propTypes = {
	isOpened: PropTypes.bool,
	close: PropTypes.func.isRequired,
	photos: PropTypes.array,
};

export default memo(SlideShow);
